import { GET_MAGIC_ALGORITHM_RESULTS } from 'actions/actionTypes';
import { getMagicAlgorithmResults } from 'api/magicAlgorithm';
import {
  getMagicAlgorithmResultsSuccess,
  getMagicAlgorithmResultsFailure,
} from 'actions';
import { apiPromise } from './apiPromise';

export const magicAlgorithmData = store => next => (action) => {
  switch (action.type) {
    case GET_MAGIC_ALGORITHM_RESULTS.REQUEST: {
      next(action);
      return apiPromise(
        store,
        action,
        getMagicAlgorithmResults,
        [],
        getMagicAlgorithmResultsSuccess,
        getMagicAlgorithmResultsFailure
      );
    }
    default:
      next(action);
      return Promise.resolve();
  }
};

export default magicAlgorithmData;
